import { TECHNICIAN } from 'constants/ModeConstants';
import { createDictionary } from 'utils/ObjectUtils';

export const IMPORT_TIRE_REPORT_NOTIF = createDictionary(
  {
    [TECHNICIAN]: {
      id: 'page.fiche.form.tireReport.import.checklist',
      defaultMessage: 'Tire report works added to the checklist'
    }
  },
  {
    id: 'page.fiche.form.tireReport.import.offer',
    defaultMessage: 'Tire report items added to the offer'
  }
);
